import FolderInfoResponseMessage from 'owa-service/lib/contract/FolderInfoResponseMessage';
import PropertyUpdate from 'owa-service/lib/contract/PropertyUpdate';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';

import updateFolderRequest from 'owa-service/lib/factory/updateFolderRequest';
import folderId from 'owa-service/lib/factory/folderId';

import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import updateFolderOperation from 'owa-service/lib/operation/updateFolderOperation';
import getFullFolderId from '../util/getFullFolderId';
import getDefaultRequestOptions from './getDefaultRequestOptions';

export default function updateFolder(
    folderIdToUpdate: string | DistinguishedFolderIdName,
    propertyUpdates: PropertyUpdate[]
): Promise<FolderInfoResponseMessage> {
    return updateFolderOperation(
        {
            Header: getJsonRequestHeader(),
            Body: updateFolderRequest({
                FolderChanges: [
                    {
                        Updates: propertyUpdates,
                        FolderId: folderId(getFullFolderId(folderIdToUpdate)),
                    },
                ],
            }),
        },
        getDefaultRequestOptions(folderIdToUpdate)
    ).then(response => {
        return response.Body.ResponseMessages.Items[0];
    });
}
